import type { ReactNode } from 'react';

interface SectionHeaderProps {
  index: string;
  title: string;
  highlight?: string;
  description?: ReactNode;
  align?: 'left' | 'center';
  className?: string;
}

export default function SectionHeader({
  index,
  title,
  highlight,
  description,
  align = 'left',
  className = '',
}: SectionHeaderProps) {
  const isCenter = align === 'center';

  return (
    <header
      className={`mb-16 xl:mb-24 ${isCenter ? 'text-center' : 'text-left'} ${className}`}
    >
      <p className="font-mono text-sand text-xs tracking-[0.2em] uppercase mb-4">
        {index}
      </p>
      <h2 className="font-display text-4xl sm:text-5xl xl:text-6xl font-700 text-parchment leading-[1.05] text-balance">
        {title}
        {highlight && (
          <>
            {' '}
            <span className="gradient-text italic font-600">{highlight}</span>
          </>
        )}
      </h2>
      {description && (
        <p
          className={`mt-5 text-parchment-muted text-lg leading-relaxed max-w-xl ${
            isCenter ? 'mx-auto' : ''
          }`}
        >
          {description}
        </p>
      )}
      <div
        className={`mt-6 h-px w-24 bg-gradient-to-r from-sand/60 to-transparent ${
          isCenter ? 'mx-auto' : ''
        }`}
      />
    </header>
  );
}
